import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { BreadcrumbsComponent } from './breadcrumbs.component'
import { RouterModule } from '@angular/router'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'
import { TranslateModule } from '@ngx-translate/core'

@NgModule({
  declarations: [BreadcrumbsComponent],
  imports: [
    TranslateModule,
    ContentEditableModule,
    CommonModule, // Provides Angular directives like *ngFor, *ngIf
    RouterModule, // Allows routerLink to work in the component
  ],
  exports: [BreadcrumbsComponent], // Makes the component available for other modules
})
export class BreadcrumbsModule {}
